/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { HlpListItemDto, ListingStatus, UserListItemDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export type HlpDetails = {
  houseAndLandPackageId: string;
  hlpNumber: number;
  housePlanId: string;
  externalId: string;
  base: string;
  memo: string;
  debit: number;
  credit: number;
  profit: number;
  status: number;
  pbPrice: number;
  storeys: number;
  version: number;
  bedrooms: number;
  bathrooms: number;
  carSpaces: number;
  floorArea: number;
  floorAreaUom: number;
  landArea: number;
  landAreaUom: string;
  images: HlpDesignImage[];
  totalPrice1: string;
  totalPrice2: string;
  displayPrice: string;
  priceBookId: string;
  priceBookName: string;
  housePlanCode: string;
  housePlanName: string;
  siteName: string;
  siteStreet: string;
  siteSuburb: string;
  sitePostcode: string;
  siteAddress: string;
  siteLotNumber: number;
  siteStreetNumber: number;
  siteUrl: string;
  adjSalesTax: string;
  baseDesignId: string;
  origSalesTax: string;
  pbSalesPrice: string;
  totalSalesTax: string;
  salespersonId: string;
  salespersonName: string;
  alternateSalespersonId: string;
  alternateSalespersonName: string;
  baseDesignName: string;
  baseHousePlanId: string;
  designSeriesName: string;
  baseHousePlanCode: string;
  baseHousePlanName: string;
  features: {id: ID; name: string; externalId: number}[];
  additionalFeatures: any[];
  salesTaxRates: any[];
  variations: any[];
  listingStatus: ListingStatus;
  websiteDescription: string;
  quoteDescription: string;
  origSalesTaxPct: number;
  publishedById: number;
  publishedDate: number;
  publishedByName: string;
  isRounded: boolean;
  isDisplayPriceOverridden: boolean;
  isPublishedOnDomainComAu: boolean;
  isPublishedOnRealestateComAu: boolean;
  salesperson?: { name: string; id: string };
};

export type HlpDesignImage = {
  id: ID;
  name?: string;
  type: number;
  links: {
    big: string;
    small: string;
    medium: string;
    original: string;
  };
  order: number;
  entity?: string;
  entity_id?: ID;
  facadeTypeId?: string;
  facadeTypeName?: string;
};

export type HlpDetailsDesign = {
  designSeries: string;
  designName: string;
  stories: string;
  bedrooms: number;
  bathrooms: number;
  carSpaces: number;
  images: HlpDesignImage[];
  floorArea: string;
  floorAreaUom: string;
  description: string;
  features: {id: ID; name: string}[];
  additionalFeatures: string[];
};

export type HlpListItem = HlpListItemDto & {
  masterZoneId?: ID;
  officeId?: ID;
};

export type SalespersonSelectItem = {
  id: ID;
  name: string;
  status?: string;
};

export type UserListItem = UserListItemDto;

export const isSalespersonSelectItemInactive = ({ status }: SalespersonSelectItem): boolean =>
  status === 'INACTIVE' || status === 'DELETED';

export const salespersonSelectItemMapper =
  ({ userId, userName, status }: UserListItem) => ({ id: userId, name: userName, status });
export const ALL_SALESPERSON_SELECT_VALUE = '_All';
